import * as types from './mutation-types';
import actions from './actions';
import { Scene, LoadingManager, Vector3, Vector2, Raycaster } from 'three';

export default {
    namespaced: true,
    strict: true,
    state: {
        sceneLeft: new Scene(),
        sceneRight: new Scene(),
        camera: null,
        renderer: null,
        pmremGenerator: null,
        mouse: new Vector2(),
        raycaster: new Raycaster(),
        cameraLookat: new Vector3(0, 3, 0),
        loadingManager: new LoadingManager(),
        total: 0,
        loaded: 0,
        loadFinished: false,
        envMap: null,
        controls: null,
        hotspots: [],
        hotspotOffTexture: null,
        hotspotOnTexture: null
    },
    mutations: {
        [types.CAMERA](state, camera) {
            state.camera = camera;
        },
        [types.RENDERER](state, renderer) {
            state.renderer = renderer;
        },
        [types.PMREMGENERATOR](state, pmremGenerator) {
            state.pmremGenerator = pmremGenerator;
            state.pmremGenerator.compileEquirectangularShader();
        },
        [types.ENV_MAP](state, envMap) {
            state.envMap = envMap;
        },
        [types.CONTROLS](state, controls) {
            state.controls = controls;
        },
        [types.LOADED_TOTAL](state, total) {
            state.total = total;
        },
        [types.LOADED_ITEMS](state, loaded) {
            state.loaded = loaded;
        },
        [types.LOAD_FINISHED](state, finished) {
            state.loadFinished = finished;
        },
        [types.LOADING_MANAGER](state, loadingManager) {
            state.loadingManager = loadingManager;
        },
        [types.HOTSPOTS](state, hotspots) {
            state.hotspots = hotspots;
        },
        [types.HOTSPOT_OFF_TEXTURE](state, texture) {
            state.hotspotOffTexture = texture;
        },
        [types.HOTSPOT_ON_TEXTURE](state, texture) {
            state.hotspotOnTexture = texture;
        }
    },
    actions,
    getters: {}
};
